import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import dayjs from "dayjs";
import { companyId, userId } from "../../../../utils/companyId";
import InputField from "../../../../Components/Masters/InputField";
import SelectField from "../../../../Components/Masters/SelectField";
import FileField from "../../../../Components/Masters/FileField";
import {
  validateNumber,
  validateString,
} from "../../../../utils/validateFields";
import DateField from "../../../../Components/Masters/DateField";
import { put, post, get } from "../../../../utils/api";
import { numberError, textError } from "../../../../utils/validationMessage";
import Multiline from "../../../../Components/Masters/Multiline";
import EditDialog from "../../../../Components/Common/EditDialog";
import LocationAutocomplete from "../../../../Components/Common/LocationAutocomplete";
import InputDate from "../../../../Components/Masters/InputDate";
import formatTitleWithOptional from "../../../Scope1/OptionalFeild";
import GoogleMapsAutocomplete from "../../../../Components/Common/GoogleMapsAutocomplete";
import { parseAddressComponents } from "../../../../utils/common";
import { useUser } from "../../../../context/AuthContext";

function AddRoad({
  inputData,
  fetchData,
  id,
  title,
  data,
  setAddData,
  SelectedData,
  addData,
  setsnackOpen,
  addUrl,
  updateUrl,
  onClose,
  resetSelectedData,
}) {
  const { user } = useUser();

  const [errors, setErrors] = useState({});
  const initialState = {
    tripDate: SelectedData?.tripDate || "",
    source: SelectedData?.source || "",
    destination: SelectedData?.destination || "",
    vehicle: SelectedData?.vehicle?._id || "",
    driver: SelectedData?.driver?._id || "",
    associatedVendor: SelectedData?.associatedVendor?._id || "",
    transportationType: SelectedData?.transportationType || "",
    dataEntryMode: SelectedData?.dataEntryMode || "",
    distanceTravel: {
      value: SelectedData?.distanceTravel?.value ?? "",
      unit: SelectedData?.distanceTravel?.unit || "",
    },
    declaredEfficiency: SelectedData?.declaredEfficiency || "",
    remarks: SelectedData?.remarks || "",
    documents: SelectedData?.documents || [],
    company: companyId,
    createdBy: userId,
    editRemarkReason: SelectedData?.editRemarkReason || "",
  };
  const [editDialog, setEditDialog] = useState(false);
  const [formData, setFormData] = useState(initialState);
  const [formData2, setFormData2] = useState(initialState);
  const [date, setDate] = useState();
  const [time, setTime] = useState();
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [driverlist, setDriverlist] = useState([]);
  const [vehiclelist, setVehiclelist] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});
  const [declaredEfficiency, setDeclarEfficiency] = useState({
    value: "",
    unit: "",
  });
  const [Brandmodel, setBrandModel] = useState({
    model: "",
    brand: "",
  });
  const [coordinates, setCoordinates] = useState({
    origin: {
      lat: 0,
      lng: 0,
    },
    destination: {
      lat: 0,
      lng: 0,
    },
  });
console.log("errors",errors)
  const resetFrom = () => {
    setFormData(initialState);
    setFormData2(initialState);
    setUploadedFiles(SelectedData?.documents || []);
    setTime(
      SelectedData ? dayjs(SelectedData?.startDateAndTime?.time) : null,
    );
    setDate(
      SelectedData ? dayjs(SelectedData?.startDateAndTime?.date) : null,
    );
    setDeclarEfficiency({
      value: SelectedData?.vehicle?.declaredEfficiency?.value ?? "",
      unit: SelectedData?.vehicle?.declaredEfficiency?.unit ?? "",
    });
    setBrandModel({
      model: SelectedData?.vehicle?.model ?? "",
      brand: SelectedData?.vehicle?.brand ?? "",
    });
    if (SelectedData) {
      setDriverlist(SelectedData?.driver ? [SelectedData.driver] : []);
      setVehiclelist(SelectedData?.vehicle ? [SelectedData.vehicle] : []);
    } else {
      setDriverlist([]);
      setVehiclelist([]);
    }
  };
  const handleDateChange = ({ name, value }) => {
    // Correctly extract name and value from e.target
    //  const { name, value } = e.target;
    // Clear the specific error for the field being changed
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: undefined, // Remove error for the specific field
    }));
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (SelectedData !== null) {
      setFormData(initialState);
      setFormData2(initialState);
      setDriverlist([SelectedData?.driver] || []);
      setVehiclelist([SelectedData?.vehicle] || []);
      setDeclarEfficiency({
        value: SelectedData?.vehicle?.declaredEfficiency?.value,
        unit: SelectedData?.vehicle?.declaredEfficiency?.unit,
      });
      setBrandModel({
        model: SelectedData?.vehicle?.model,
        brand: SelectedData?.vehicle?.brand,
      });
      setDate(dayjs(SelectedData?.startDateAndTime?.date));
      setTime(SelectedData?.startDateAndTime?.time);
      setUploadedFiles(SelectedData?.documents || []);
    } else {
      resetFrom();
    }
  }, [SelectedData]);

  const handleLocationChange = (fieldName, value) => {
    const addressDetails = parseAddressComponents(
      value?.name,
      value?.address_components
    );
    setFormData((prevFormData) => ({
      ...prevFormData,
      [fieldName]: addressDetails,
    }));
    setCoordinates((prevCoordinates) => ({
      ...prevCoordinates,
      [fieldName === "source" ? "origin" : fieldName]: value?.location,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: "",
    }));
  };

  const handleonChange = (e) => {
    const { name, value } = e.target;
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const fetchdeclaredEfficiency = async (id) => {
    await get(`/master/getByIDVechile?_id=${id}`)
      .then((res) => {
        setDeclarEfficiency({
          value: res.data.data.declaredEfficiency.value,
          unit: res.data.data.declaredEfficiency.unit,
        });
        setBrandModel({
          model: res.data.data.model,
          brand: res.data.data.brand,
        });
      })
      .catch((err) => console.log(err, "getting res"));
  };
  const fetchdriver = async (value) => {
    await get(`/driver/master/getAll`)
      .then((res) => {
        const name = res.data.data.filter(
          (item) => item.logisticsVendor?._id === value
        );
        // const driverNames = name.map((item) => item.driverName);
        // console.log(res.data.data,value,name,driverNames,"fordriver")
        setDriverlist(name);
      })
      .catch((err) => console.log(err, "getting res"));
    await get(`/master/getAllVehicle`)
      .then((res) => {
        const name = res.data.data.filter(
          (item) => item.logisticVendor?._id === value
        );
        setVehiclelist(name);
        console.log(res, value, name, "resopnse");
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const fetchVehicle = async () => {
    await get(`/master/getAllVehicle`)
      .then((res) => {
        const name = res?.data?.data.filter(
          (item) => item.logisticVendor?._id === formData?.associatedVendor
        );
        setVehiclelist(name);
      })
      .catch((err) => console.log(err, "getting res"));
  };

  useEffect(() => {
    fetchVehicle();
  }, [formData?.associatedVendor]);

  useEffect(() => {
    fetchVehicle();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    const [key, subKey] = name.split(".");
    setErrors((prevErrors) => {
      // Clear errors for the specific field being updated
      if (subKey) {
        return {
          ...prevErrors,
          [key]: { ...prevErrors[key], [subKey]: undefined },
        };
      }
      return { ...prevErrors, [name]: undefined };
    });
    if (key === "vehicle") {
      fetchdeclaredEfficiency(value);
    }
    if (key === "associatedVendor") {
      fetchdriver(value);
    }
    setFormData((prevState) => {
      if (subKey) {
        // Update nested field
        return {
          ...prevState,
          [key]: { ...prevState[key], [subKey]: value },
        };
      }
      // Update regular field
      return { ...prevState, [name]: value };
    });
  };
  const handleExitAgree = () => {
    setEditDialog(false);
    setErrors({});
    resetFrom();
    setCoordinates({
      origin: { lat: 0, lng: 0 },
      destination: { lat: 0, lng: 0 },
    });
    setAddData(false);
    resetSelectedData?.();
    onClose?.();
  };

  const handleClose = () => {
    const isFormDataUnchanged = Object.keys(formData).every(
      (key) => formData[key] === formData2[key]
    );
    const isFilesUnchanged =
      JSON.stringify(uploadedFiles) ===
      JSON.stringify(formData2?.documents || []);

    if (isFormDataUnchanged && isFilesUnchanged) {
      handleExitAgree();
    } else {
      setEditDialog(true); // Show the EditDialog if there are changes
    }
  };
  const validateForm = () => {
    const newErrors = {};

    inputData.forEach((input) => {
      const value = formData[input.fieldName];

      // Check for calorificValue separately
      // if (
      //   formData?.dataEntryMode === "Manual" &&
      //   input.fieldName === "distanceTravel"
      // ) {
      //   const cvValue = formData[input.fieldName]?.value || ""; // Ensure it's a string
      //   const cvUnit = formData[input.fieldName]?.unit || ""; // Ensure it's a string

      //   if (!validateNumber(cvValue)) {
      //     newErrors[input.fieldName] = {
      //       ...newErrors[input.fieldName],
      //       value: "Numeric Value required.",
      //     };
      //   }

      //   if (!cvUnit.trim()) {
      //     newErrors[input.fieldName] = {
      //       ...newErrors[input.fieldName],
      //       unit: "Unit is required.",
      //     };
      //   }
      //   return; // Ensure to return after handling errors for calorificValue
      // }

      if (
        formData?.dataEntryMode === "Manual" &&
        input.fieldName === "declaredEfficiency"
      ) {
        if (!validateNumber(declaredEfficiency?.value)) {
          newErrors[input.fieldName] = numberError;
          return; // Stop further checks for this input
        }
      }
      // Skip validation for hours and industrialEquipment if not in Individual mode

      // Validation for numeric inputs
      if (input.type === "number") {
        if (!validateNumber(value)) {
          newErrors[input.fieldName] = numberError;
          return; // Stop further checks for this input
        }
      }
      if (
        input.fieldName === "source" ||
        input.fieldName === "destination" ||
        input.fieldName === "tripDate"
      ) {
        if (!validateString(value)) {
          newErrors[input.fieldName] = textError;
          return; // Stop further checks for this input
        }
      }
      if (input.type === "text") {
        if (!validateString(value)) {
          newErrors[input.fieldName] = textError;
          return; // Stop further checks for this input
        }
      }

      // if (input.fieldName === "documents" && uploadedFiles.length === 0) {
      //   console.log(input.fieldName, uploadedFiles);
      //   newErrors[input.fieldName] = `Please upload Documents`;
      // }

      if (
        input.fieldName === "driver" &&
        (formData?.dataEntryMode === "" || formData?.dataEntryMode === "App") &&
        (!value || value === "")
      ) {
        newErrors[input.fieldName] = `${input.title} is required.`;
        return;
      }

      if (
        input.fieldName === "driver" &&
        formData?.dataEntryMode === "Manual"
      ) {
        return;
      }

      // Additional checks for required fields
      if (
        input.required &&
        input.type !== "number" &&
        input.fieldName !== "brand" &&
        input.fieldName !== "model" &&
        (!value || value === "")
      ) {
        newErrors[input.fieldName] = `${input.title} is required.`;
      }

      if (user?.endUser && id && input.fieldName === "editRemarkReason") {
        if (
          !formData[input.fieldName] ||
          formData[input.fieldName].trim() === ""
        ) {
          newErrors[input.fieldName] = "Edit Remark Reason is required";
        }
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const Save = async () => {
    if (!validateForm()) return;

    // Prepare data to send, including only fields with values
    const dataToSend = {
      ...formData,
      documents: uploadedFiles,
      declaredEfficiency: declaredEfficiency?.value,
    };

    // Conditionally delete fields if typeOfEntry is not "Individual"
    if (formData.dataEntryMode !== "Manual") {
      delete dataToSend.distanceTravel;
      delete dataToSend.declaredEfficiency;
    }
    delete dataToSend._id;

    // Remove fields that have empty values
    // Object.keys(dataToSend).forEach((key) => {
    //   if (
    //     dataToSend[key] === "" || // Empty strings
    //     (typeof dataToSend[key] === "object" &&
    //       Object.keys(dataToSend[key]).length === 0) // Empty objects
    //   ) {
    //     delete dataToSend[key];
    //   }
    // });
    if (user?.endUser && id) {
      dataToSend.requestStatus = "edit";
      dataToSend.requestMode = true;
      dataToSend.approvalStatus = "Pending";
    }
    let method = SelectedData?._id ? put : post;
    let url = SelectedData?._id
      ? `${updateUrl}?Id=${SelectedData?._id}`
      : addUrl;
    //  params: SelectedData?._id ? { Id: SelectedData?._id } : null, // Send params only for PUT request
    await method(url, {
      ...dataToSend,
    })
      .then((res) => {
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        fetchData();
        setFormData(initialState);
        setUploadedFiles([]);
        onClose();
        resetFrom();
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.errors) {
          const errorMessages = err.response.data.errors
            .map((error) => error.msg)
            .join(", ");
          setsnackOpen({
            open: true,
            message: errorMessages,
            severity: "error",
          });
        }
      });
  };

  const renderInputField = (el) => {
    if (
      formData?.dataEntryMode === "Manual" &&
      formData?.dataEntryMode !== "" &&
      el.fieldName === "distanceTravel"
    ) {
      const isDisabled = el.fieldName === "distanceTravel";
      return (
        <Box display="flex" gap={1} sx={{ width: "100%" }}>
          <Box sx={{ width: "55%" }}>
            <InputField
              title={formatTitleWithOptional(el.title)}
              handleChange={handleChange}
              placeholder={el.placeholder}
              value={formData[el.fieldName]?.value ?? ""}
              errors={errors[el.fieldName]?.value} // Access error for value
              fieldName={`${el.fieldName}.value`}
              disabled={isDisabled}
            />
          </Box>
          <Box sx={{ width: "45%", mt: "9%" }}>
            <SelectField
              // name={["fuelConsumed", "distanceTravel"].includes(formData)}
              name={`${el.fieldName}.unit`}
              // disable={true}
              disable={isDisabled}
              // value={formData.fuelConsumed?.unit}
              value={formData[el.fieldName]?.unit || ""}
              handleChange={handleChange}
              options={
                ["distanceTravel"].includes(el.fieldName)
                  ? ["km"]
                  : ["km", "mile"]
              }
              errors={errors[el.fieldName]?.unit} // Access error for unit
              field={el.field}
              defaultValue="Select Unit"
            />
          </Box>
        </Box>
      );
    }
    if (el.options || el.type === "select") {
      return (
        <SelectField
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          value={formData?.[el.fieldName]}
          handleChange={handleChange}
          options={el.options}
          errors={errors[el.fieldName]}
          url={el.url}
          field={el.field}
        />
      );
    }
    if (el.fieldName === "driver") {
      return (
        <SelectField
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          value={formData?.[el.fieldName]}
          handleChange={handleChange}
          options={driverlist}
          errors={errors[el.fieldName]}
          // url={el.url}
          field={"driverName"}
          disable={driverlist.length > 0 ? false : true}
        />
      );
    }
    if (el.fieldName === "vehicle") {
      return (
        <SelectField
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          value={formData?.[el.fieldName]}
          handleChange={handleChange}
          options={vehiclelist}
          errors={errors[el.fieldName]}
          // url={el.url}
          field={"vehicleNumber"}
          disable={vehiclelist.length > 0 ? false : true}
        />
      );
    }
    if (el.type === "file") {
      return (
        <FileField
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          errors={errors[el.fieldName]}
          fileUrls={uploadedFiles}
          progress={uploadProgress[el.fieldName] || []}
          {...{ setUploadedFiles, setUploadProgress, setErrors }}
          // onDelete={handleDeleteFile}
        />
      );
    }

    if (el.fieldName === "remarks")
      return (
        <Multiline
          title={formatTitleWithOptional(el.title)}
          handleChange={handleChange}
          placeholder={el.placeholder}
          value={formData[el.fieldName] || ""}
          errors={errors[el.fieldName]}
          fieldName={el.fieldName}
        />
      );

    if (el.fieldName === "editRemarkReason") {
      if (user?.endUser && id) {
        return (
          <Multiline
            title={formatTitleWithOptional(el.title)}
            handleChange={handleChange}
            placeholder={el.placeholder}
            value={formData[el.fieldName] || ""}
            errors={errors[el.fieldName]}
            fieldName={el.fieldName}
            required={true}
          />
        );
      }
      return null;
    }
    if (el.fieldName === "reasonForDeviation")
      return (
        <Multiline
          title={formatTitleWithOptional(el.title)}
          handleChange={handleChange}
          placeholder={el.placeholder}
          value={formData[el.fieldName] || ""}
          errors={errors[el.fieldName]}
          fieldName={el.fieldName}
        />
      );
    if (el.type === "radio") {
      return (
        <>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
            {el?.title}
          </Typography>

          <RadioGroup
            row
            name={el.fieldName}
            value={formData?.[el.fieldName] || ""}
            onChange={handleonChange}
          >
            {el.option.map((option, index) => {
              return (
                <Box
                  key={el.keys[index]}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  <FormControlLabel
                    // key={el.keys[index]}
                    value={el.keys[index]}
                    control={<Radio />}
                    label={option}
                  />
                  {el.paragraph[index] && (
                    <Typography
                      sx={{ fontSize: "14px", fontWeight: "400" }}
                      variant="body2"
                    >
                      {el.paragraph[index]}
                    </Typography>
                  )}
                </Box>
              );
            })}
          </RadioGroup>
          {errors[el.fieldName] && (
            <Typography sx={{ color: "error.main" }} variant="body2">
              {errors[el.fieldName]}
            </Typography>
          )}
        </>
      );
    }
    if (el.type === "date") {
      return (
        <Box>
          <InputDate
            title={formatTitleWithOptional(el.title)}
            name={el.fieldName}
            noMaxDate={true}
            value={formData?.[el.fieldName]}
            handleChange={handleDateChange}
            errors={errors[el.fieldName]}
          />
        </Box>
      );
    }
    if (el.type === "LocationAutocomplete") {
      return (
        <>
          {/* <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", mt: 1, marginBottom: "-0.5rem" }}
          >
            {el?.title}
          </Typography> */}
          {/* <LocationAutocomplete
            key={el.fieldName}
            queryType={el.queryType}
            value={formData?.[el.fieldName]}
            onChange={(newValue) =>
              handleLocationChange(el.fieldName, newValue)
            }
            placeholder={el.placeholder}
            error={Boolean(errors[el.fieldName])}
            helperText={errors[el.fieldName] || ""}
          /> */}

          <GoogleMapsAutocomplete
            title={el.title}
            placeholder={el.placeholder}
            onPlaceSelect={(newValue) =>
              handleLocationChange(el.fieldName, newValue)
            }
            error={errors[el.fieldName]}
            // type={["geocode"]}
            type={[]}
            value={formData?.[el.fieldName]}
          />
          {/* {errors?.[el.fieldName] && (
            <Typography variant="body2" color="#D34040">
              {errors?.[el.fieldName]}
            </Typography>
          )} */}
        </>
      );
    }
    if (el.fieldName === "model" || el.fieldName === "brand") {
      return (
        <InputField
          title={formatTitleWithOptional(el.title)}
          // handleChange={handleChange}
          placeholder={el.placeholder}
          disabled={true}
          value={Brandmodel?.[el.fieldName] || ""}
          errors={errors[el.fieldName]}
          fieldName={el.fieldName}
          // adornmentText={declaredEfficiency?.unit || ""} // Pass error prop
        />
      );
    }
    if (
      formData?.dataEntryMode === "Manual" &&
      formData?.dataEntryMode !== "" &&
      el.fieldName === "declaredEfficiency" &&
      el.fieldName === "model" &&
      el.fieldName === "brand"
    ) {
      return (
        <InputField
          title={formatTitleWithOptional(el.title)}
          handleChange={handleChange}
          placeholder={el.placeholder}
          disabled={true}
          value={declaredEfficiency?.value || ""}
          errors={errors[el.fieldName]}
          fieldName={el.fieldName}
          adornmentText={declaredEfficiency?.unit || ""} // Pass error prop
        />
      );
    }
    // return (
    //   <InputField
    //    title={formatTitleWithOptional(el.title)}
    //     handleChange={handleChange}
    //     placeholder={el.placeholder}
    //     value={formData[el.fieldName] || ""}
    //     errors={errors[el.fieldName]}
    //     fieldName={el.fieldName}
    //     adornmentText={el.adornmentText || ""} // Pass error prop
    //   />
    // );
  };

  const fetchDistance = async () => {
    try {
      let response = await get(
        `/scope3/roadTransportation/distance?origin=${
          formData?.source
        }&destination=${
          formData.destination
        }&originCoordinates=${JSON.stringify(
          coordinates?.origin
        )}&destinationCoordinates=${JSON.stringify(coordinates?.destination)}`
      );
      const rawDistance = response?.data?.data;
      const numericDistance = Number(rawDistance);
      setFormData((prevData) => ({
        ...prevData,
        distanceTravel: {
          value: Number.isFinite(numericDistance) ? numericDistance : "",
          unit: "km",
        },
      }));
    } catch (error) {
      console.error("Error fetching ships:", error);
    }
  };

  useEffect(() => {
    if (formData.source && formData.destination) {
      const handler = setTimeout(() => {
        fetchDistance(formData.source, formData.destination, setFormData);
      }, 1000);
      return () => clearTimeout(handler);
    }
  }, [formData.source, formData.destination]);

  const list = () => (
    <Box display="flex" gap={3} sx={{ width: "26rem", maxWidth: "100%" }}>
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={handleClose} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box sx={{ width: "88%", p: 3, backgroundColor: "#fff" }}>
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          {SelectedData?._id ? `Edit Data` : `Add Data`}
          {/* AddData */}
        </Typography>
        {inputData.map((el) => {
          // Conditional rendering for hours and industrial equipment
          if (
            (el.fieldName === "hours" ||
              el.fieldName === "industrialEquipment") &&
            formData.typeOfEntry !== "Individual"
          ) {
            return null; // Skip rendering these fields if typeOfEntry is not "Individual"
          }

          return <div key={el.fieldName}>{renderInputField(el)}</div>;
        })}
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={Save}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Drawer
      sx={{
        backgroundColor: "transparent",
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
          height: "100vh",
          minHeight: "100vh",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
      anchor="right"
      open={addData}
      onClose={handleClose}
    >
      {list()}
    </Drawer>
  );
}

export default AddRoad;
